import React from 'react';
import styled from 'styled-components';

// shared components
import Container from '~/App/shared/components/Container';
import { Donation } from '~/App/shared/components/Donation';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightPolar};
`;

export default function DonationForm({ data }) {
  return (
    <Wrapper>
      <Container
        width="limited"
        paddingLeft="small"
        paddingRight="small"
        paddingTop="small"
        paddingBottom="small"
      >
        <Donation data={data} />
      </Container>
    </Wrapper>
  );
}
